document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('[data-m-header]');
  const toggle = document.querySelector('[data-m-menu-toggle]');
  const dropdown = document.querySelector('[data-m-menu-dropdown]');
  const menuLabel = document.querySelector('[data-m-menu-label]');

  if (!header || !toggle || !dropdown) return;

  function findAnnouncementBar() {
    const selectors = [
      '.m-trust-bar',
      '[data-announcement-bar]',
      '.announcement-bar',
      '.utility-bar',
      '.shopify-section-group-header-group .announcement-bar',
      '.shopify-section-group-header-group .utility-bar',
      '[class*="announcement-bar"]',
      '[id*="shopify-section-announcement"]',
      '[id*="announcement-bar"]'
    ];

    for (let i = 0; i < selectors.length; i++) {
      const match = document.querySelector(selectors[i]);

      if (match && match !== header && match.offsetHeight > 0) {
        return match.closest('.shopify-section') || match;
      }
    }

    return null;
  }

  function getHeaderGap() {
    return window.innerWidth <= 749 ? 12 : 16;
  }

  function getHeaderHeight() {
    return header.offsetHeight || 0;
  }

  function getAnnouncementHeight() {
    const announcementBar = findAnnouncementBar();
    return announcementBar ? announcementBar.offsetHeight : 0;
  }

  function setPageOffset() {
    const gap = getHeaderGap();
    const headerHeight = getHeaderHeight();
    const totalOffset = headerHeight + gap;

    document.documentElement.style.setProperty('--m-page-header-offset', totalOffset + 'px');

    const candidates = [
      document.getElementById('MainContent'),
      document.querySelector('main'),
      document.querySelector('[role="main"]'),
      document.querySelector('.shopify-section-group-template-group'),
      document.querySelector('#shopify-section-template--main'),
      document.querySelector('.template-index')
    ].filter(Boolean);

    candidates.forEach(function (element) {
      element.style.paddingTop = totalOffset + 'px';
    });

    const firstTemplateSection = document.querySelector(
      '.shopify-section-group-template-group > .shopify-section, main .shopify-section, [role="main"] .shopify-section'
    );

    if (firstTemplateSection) {
      firstTemplateSection.style.marginTop = '0';
    }
  }

  function syncHeaderPosition() {
    const announcementHeight = getAnnouncementHeight();
    const gap = getHeaderGap();
    const scrollTop = window.scrollY || window.pageYOffset;

    if (announcementHeight === 0) {
      header.style.setProperty('--m-header-top', gap + 'px');
      header.classList.add('is-stuck');
      return;
    }

    if (scrollTop < announcementHeight) {
      header.style.setProperty('--m-header-top', announcementHeight + gap + 'px');
      header.classList.remove('is-stuck');
    } else {
      header.style.setProperty('--m-header-top', gap + 'px');
      header.classList.add('is-stuck');
    }
  }

  function refreshLayout() {
    setPageOffset();
    syncHeaderPosition();
  }

  function openMenu() {
    header.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    dropdown.setAttribute('aria-hidden', 'false');

    if (menuLabel) {
      menuLabel.textContent = 'Close';
    }

    refreshLayout();
  }

  function closeMenu() {
    header.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    dropdown.setAttribute('aria-hidden', 'true');

    if (menuLabel) {
      menuLabel.textContent = 'Menu';
    }

    refreshLayout();
  }

  function toggleMenu(event) {
    event.preventDefault();
    event.stopPropagation();

    if (header.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  toggle.addEventListener('click', toggleMenu);

  dropdown.addEventListener('click', function (event) {
    event.stopPropagation();
  });

  document.addEventListener('click', function () {
    if (header.classList.contains('is-open')) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && header.classList.contains('is-open')) {
      closeMenu();
    }
  });

  window.addEventListener(
    'scroll',
    function () {
      syncHeaderPosition();
    },
    { passive: true }
  );

  window.addEventListener('resize', refreshLayout);

  window.addEventListener('load', function () {
    closeMenu();
  });

  closeMenu();
});